const GOOGLE_AUDIENCE_PIXEL = {
  id: 'google-pcd-tag',
  src: 'https://pagead2.googlesyndication.com/pagead/js/pcd.js',
  audiencePixel: 'dc_iu=/242748299/DFPAudiencePixel;dc_seg=9440129194',
} as const;

export function ensureGoogleAudiencePixel() {
  if (typeof document === 'undefined') return;
  if (document.getElementById(GOOGLE_AUDIENCE_PIXEL.id)) return;

  const script = document.createElement('script');
  script.async = true;
  script.id = GOOGLE_AUDIENCE_PIXEL.id;
  script.src = GOOGLE_AUDIENCE_PIXEL.src;
  script.setAttribute('data-audience-pixel', GOOGLE_AUDIENCE_PIXEL.audiencePixel);
  document.body.appendChild(script);
}
